import { createSelector } from 'reselect';
import { filter, mapTagsLocationName } from '../transform';
import { listViewColumns } from '../../constants/data';

const getTags = state => state.tags.data;
const getFilters = state => state.tags.filters;

/**
  @name getAllTags
  Selector to obtain the filtered list of all tags
*/
const getAllTags = createSelector(
  [getTags, getFilters],
  (tags, filters) => mapTagsLocationName(filter(tags, filters, listViewColumns))
);

export default getAllTags;



// WEBPACK FOOTER //
// ./src/utils/selectors/getAllTags.js